import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { ILocation } from 'src/types/Location';

type UseSetLocationsFormField = {
  initialLocationsValue: Partial<ILocation>[];
};

type Locations = { [id: string]: string };

export const useSetLocationsFormField = (
  submittedLocationSelections?: Locations
): UseSetLocationsFormField => {
  const [initialLocationsValue, setInitialLocationsValue] = useState<
    Partial<ILocation>[]
  >([]);
  const { setValue } = useFormContext();

  useEffect(() => {
    const locationIds =
      submittedLocationSelections &&
      Object.keys(submittedLocationSelections).length > 0
        ? Object.keys(submittedLocationSelections)
        : null;
    if (locationIds) {
      const locationValues = locationIds.reduce((arr, id) => {
        return [...arr, { id, name: submittedLocationSelections[id] }];
      }, []);

      setInitialLocationsValue(locationValues);
      setValue('locationsExistence', 'hasLocation', {
        shouldValidate: true,
      });
      setValue('locations', submittedLocationSelections, {
        shouldValidate: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submittedLocationSelections]);

  return { initialLocationsValue };
};

export const useRegisterLocationFormField = (
  hasLocation: boolean,
  submittedLocationSelections?: Locations
): void => {
  const { unregister, setValue } = useFormContext();

  useEffect(() => {
    if (hasLocation && submittedLocationSelections) {
      setValue('locations', submittedLocationSelections, {
        shouldValidate:
          Object.keys(submittedLocationSelections || {}).length > 0,
      });
    }

    if (!hasLocation) {
      unregister('locations');
    }

    return () => {
      unregister('locations');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasLocation]);
};
